import React, { useEffect, useState, useCallback } from "react";

import notificationBill from "../../../assets/img/notificationBill.svg";
import notificationBillRed from "../../../assets/img/notificationBillRed.svg";
import MainContent from "../../../layouts/maincontent/MainContent";
import { Link } from "react-router-dom";
import Pagination from "../../../shared/pagination/Pagination";
import {
  getListNotifications,
  getNotificationDetailes,
  markAsReadNotification
} from "../../../adapters/apis/notifications/notifications";

const limit = 20;

const NotificationList = () => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount]     = useState(0);
  const [currentPage, setCurrentPage]     = useState(1);
  const [total, setTotal]                 = useState(0);
  const [loading, setLoading]             = useState(false);

  const fetchNotifications = useCallback(async (page = 1) => {
    setLoading(true);
    try {
      const res = await getListNotifications(page);
      const { data, unread_count, pagination } = res.data;

      setNotifications(data);
      setUnreadCount(unread_count);
      setCurrentPage(pagination.current_page);
      setTotal(pagination.total);
    } catch (err) {
      console.error("Failed to fetch notifications", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchNotifications(1);
  }, [fetchNotifications]);

  function callback(page) {
    fetchNotifications(page);
  }

  return (
      <MainContent>
        <section className="container pb-5" style={{ marginBottom: "80px" }}>
          {/* Header */}
          <div
              className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-3 px-0 px-md-5 mb-4 mb-md-5"
              dir="rtl"
          >
            <h1 className="fw-bold mb-0 d-flex align-items-center gap-2" style={{ color: "#005DA8" }}>
              الإشعارات
              {unreadCount > 0 && (
                  <span
                      className="badge rounded-pill"
                      style={{ backgroundColor: "#E53935", fontSize: 13 }}
                  >
                {unreadCount}
              </span>
              )}
            </h1>
          </div>

          {/* Notifications List */}
          <div
              dir="rtl"
              className="px-2 px-sm-3"
              style={{ maxHeight: "70vh", overflowY: "auto" }}
          >
            {loading ? (
                <div className="text-center py-5" style={{ color: "#005DA8" }}>
                  <div className="spinner-border" role="status" />
                </div>
            ) : notifications.length === 0 ? (
                <div className="text-center py-5" style={{ color: "#0D3E69" }}>
                  لا توجد إشعارات
                </div>
            ) : (
                notifications.map((note) => (
                    <Link
                        key={note.id}
                        type="button"
                        to={`/notification/details/${note.id}`}
                        className="w-100 text-start border-bottom rounded-3 p-4 mb-3 text-decoration-none d-block"
                        style={{
                          backgroundColor: note.is_read ? "#FEFEFF" : "#F5F5F5",
                          border: "0px",
                          cursor: "pointer",
                        }}
                    >
                      <div className="d-flex flex-column flex-sm-row justify-content-start gap-3 gap-sm-4">
                        {/* Avatar / Icon */}
                        <div
                            className="rounded-circle  flex-shrink-0 d-flex align-items-center justify-content-center"
                            style={{
                              width: "56px",
                              height: "56px",
                            }}
                        >
                          <img
                              src={note.is_read ? notificationBill : notificationBillRed}
                              alt="notification"
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                          />
                        </div>

                        {/* Title + Message */}
                        <div className="flex-grow-1 d-flex flex-column align-items-start px-2 px-sm-4">
                          <h5 className="fw-semibold mb-2" style={{ color: "#0095FF" }}>
                            {note.title_ar}
                          </h5>
                          <p className="mb-0" style={{ color: "#0D3E69", textAlign: "right" }}>
                            {note.message_ar}
                          </p>
                        </div>

                        {/* Date + Time */}
                        <div style={{ minWidth: 110, color: "#0D3E69" }}>
                          <div>{note.date}</div>
                          <div>{note.time}</div>
                        </div>
                      </div>
                    </Link>
                ))
            )}
          </div>

            {/* Pagination — نفس طريقة ListData */}
            <div className="pt-2 pb-3">
            {total > limit ? (
              <Pagination
                limit={limit}
                count={total}
                active={currentPage}
                callback={callback}
              />
            ) : null}
            </div>
        </section>
      </MainContent>
  );
};

export default NotificationList;